import { render, staticRenderFns } from "./RoleMutex.vue?vue&type=template&id=67d822cf&scoped=true&"
import script from "./RoleMutex.vue?vue&type=script&lang=js&"
export * from "./RoleMutex.vue?vue&type=script&lang=js&"
import style0 from "./RoleMutex.vue?vue&type=style&index=0&id=67d822cf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d822cf",
  null
  
)

export default component.exports